import { useCheckoutAuthStore } from "@/store/checkoutAuthStore";
import { useFetch, useNuxtApp, useRuntimeConfig } from "#app";
/**
 * A wrapper around Nuxt’s useFetch that automatically
 * attaches shoppingCartId and X-Customer to every request.
 *
 * @param {string} url       — the endpoint URL
 * @param {object} options   — useFetch options (method, body, headers, params, etc.)
 */
export async function useAuthenticatedFetch(url, options = {}) {
  const config = useRuntimeConfig();
  const authStore = useCheckoutAuthStore();
  const { $helpers, $i18n } = useNuxtApp();

  // Clone headers & params, so we don’t mutate the incoming object
  const headers = { ...(options.headers || {}) };
  const params = { ...(options.params || {}) };

  // Get storefrontId from the .env file
  headers["X-Storefront"] = `${
    $helpers.getLabelId() ?? ""
  }_${$i18n.locale.value.toUpperCase()}`;

  // Add JWT token to headers if it exists in the auth store
  if (authStore.jwt) {
    headers["Authorization"] = `Bearer ${authStore.jwt}`;
  }

  // Add shoppingCartId to headers if it exists in the store
  if (authStore.customerId) {
    headers["X-Customer"] = authStore.customerId;
  }

  // Add contactPersonId to headers if it exists in the store
  if (authStore.contactPersonId) {
    headers["X-ContactPerson"] = authStore.contactPersonId;
  }

  try {
    const data = await $fetch(url, {
      baseURL: config.public.CHECKOUT_API_URL,
      ...options,
      headers,
      params,
    });
    return { data: { value: data }, error: { value: null } };
  } catch (err) {
    return { data: { value: null }, error: { value: err } };
  }
}
